import { COUNTRY } from '@qflow/constants'

export const imperial = (country: string) => {
  return country === COUNTRY.USA
}
